import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { otpLoginUser } from '../../API/sessionsAPI';
import { getCurrentYear } from '../../utils/dateTimeFormat';

function Footer() {
  const [mobile, setUserMobile] = useState('');
  const history = useHistory();

  const currentYear = getCurrentYear();

  const userStoreSession = useSelector(
    (state) => state.UserSessionReducer.userSessionStoreData
  );

  const sendOTP = (event, isNewUserResendOTP) => {
    event.preventDefault();
    otpLoginUser({ mobile, isNewUserResendOTP })
      .then((res) => {
        if (res.data.success === true) {
          toast.success(res.data.message);
          history.push('/otp-verify', {
            mobile,
            isNewUser: res.data.isNewUser,
          });
        } else {
          toast.error(res.data.message);
        }
      })
      .catch(() => {
        toast.error('Failed to generate OTP.');
      });
  };

  // const getCurrentYear = new Date().getFullYear();

  return (
    <div className='container-fluid row mx-0 px-0'>
      <div className='row px-lg-5 mx-0 border border-2'>
        <div className='text-white container px-lg-5'>
          <div className='col-lg-4 mb-4 text-muted mt-3'>
            <h6>Download the app</h6>
            <button
              type='button'
              onClick={() =>
                window.open(
                  'https://play.google.com/store/apps/details?id=com.intelisys.app',
                  '_blank',
                  'noopener,noreferrer'
                )
              }
              style={{
                border: 'none',
                background: 'none',
                padding: 0,
                cursor: 'pointer',
              }}
              aria-label='Download on Google Play'
            >
              <img
                src='../images/playstore.webp'
                alt='Download on Google Play'
                width='170'
              />
            </button>
          </div>

          <div className='d-lg-flex justify-content-between'>
            <div className='col-lg-6 my-2 col-sm-12 col-md-12 text-start'>
              <img src='../images/logoDark.webp' width='180' alt='' />
              <p className='mt-3 text-dark' style={{ color: '#02042B' }}>
                Intelisys Ventures Private Limited is a SEBI Registered Advisory
                firm, authorized under the Securities Exchange Board of India
                with the registration number INH000011112. Our services
                encompass various areas of the financial markets, including
                Equity, MCX (Multi Commodity Exchange), Nifty, F&O (Futures and
                Options), and Currency.
                <br />
                <br />
                <span>
                  We are an authorised vendor of MCX with 15 mins Delayed Data
                </span>
              </p>
              {userStoreSession == null && (
                <div className='col-lg-6'>
                  <div className='input-group mt-3'>
                    <div className='input-group-prepend'>
                      <div className='input-group-text rounded-0'>+91</div>
                    </div>
                    <input
                      className='form-control rounded-0'
                      id='mobiletext'
                      value={mobile}
                      onChange={(e) =>
                        e.target.value.length < 11 &&
                        setUserMobile(e.target.value)
                      }
                      type='number'
                      placeholder='Enter Your Mobile No'
                    />
                    <button
                      type='button'
                      className='btn int-bg text-white btn-sm px-3 rounded-0 ms-1'
                      onClick={sendOTP}
                    >
                      Join us
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div className='d-flex flex-wrap ms-lg-5 mt-lg-0 text-start col-lg-4'>
              <div className='col-5 col-lg m-1 m-lg-0'>
                <h5 className='text-dark'>Intelisys</h5>
                <Link to='/about-us'>About Us</Link>
                <br />
                <Link to='/view-all-plans'>Our Plans</Link>
                <br />
                <Link to='/terms-conditions'>Terms & Conditions</Link>
                <br />
                <Link to='/refund-policy'>Refund Policy</Link>
                {/* <Link to='/blogs'>Blogs</Link>
                <br /> */}
              </div>
              <div className='col-5 col-lg m-1 m-lg-0'>
                <h5 className='text-dark'>Help & Support</h5>
                <Link to='/performance-report'>Performance Report</Link>
                <br />
                <Link to='/contact-us'>Contact us</Link>
                <br />
                <Link to='/sebi-compliances'>SEBI Compliances</Link>
                <br />
                <Link to='/faq'>FAQ</Link>
              </div>
            </div>
          </div>
          <div>
            <p className=' text-secondary mt-4'>Find us on : </p>
            <div className='d-flex col-12 justify-content-start '>
              <a
                className='me-4'
                href='https://www.instagram.com/intelisysinvestmentandtrading'
              >
                <i className='bi-instagram text-dark fs-5' />
              </a>
              <a
                className='me-4'
                href='https://www.youtube.com/c/IntelisysInvestmentAndTrading'
              >
                <i className='bi-youtube text-dark fs-5' />
              </a>
              <a
                className='me-4'
                href='https://www.linkedin.com/company/intelisysventures'
              >
                <i className='bi-linkedin text-dark fs-5' />
              </a>
              <a
                className='me-4'
                href='https://www.facebook.com/intelisystrading/'
              >
                <i className='bi-facebook text-dark fs-5' />
              </a>
              <a href='https://twitter.com/IntelisysT'>
                <i className='bi bi-twitter-x text-dark fs-5 mt-4 pe-4' />
              </a>
            </div>
          </div>
          <div>
            <p className='mt-3'>
              Contact us on :{' '}
              <a href='https://wa.me/918530587555'>
                {' '}
                WhatsApp (+91 85305 87555)
              </a>{' '}
            </p>
          </div>
        </div>
        <h6
          aria-hidden
          className='my-4 text-center text-decoration-underline fw-normal'
          onClick={() => window.scrollTo(0, 0)}
        >
          Back to Top <i className='bi bi-arrow-up' />
        </h6>
        <div className='container text-start text-lg-center'>
          <p className='fw-light font-monospace text-dark mb-3'>
            © {currentYear} Intelisys Ventures Pvt Ltd | All Rights Reserved |
            SEBI REG No. INH000011112
          </p>
          <p className='mb-3 fw-light font-monospace text-dark'>
            Made with ❤️ in India
          </p>
          <p className='mb-5 fw-bold font-monospace text-dark'>
            Disclaimer: Investments in securities or commodities market are
            subject to market risks, read all the related documents carefully
            before investing.
          </p>
        </div>
      </div>
      <div />
    </div>
  );
}

export default Footer;
